<template>
  <div id="app">
  <navbar></navbar>
  <section>
  <div class="tile is-ancestor">
    <div class="tile is-vertical is-6">
      <div class="tile">
        <div class="tile is-parent is-vertical">
          <article class="tile is-child notification has-background-grey-lighter">
          <h1 class="title">Search for Industry </h1>
          <h3 class="">Use Keywords or NAICS Codes to search </h3>
          <h4 class="">Example Keyword: 'Restaurant' </h4>

           <b-field label="Industry Description or NAICS Number">
               <b-autocomplete
                   :data="data"
                   class="is-expanded"
                   placeholder="e.g. Textile"
                   field="description"
                   :loading="isFetching"
                   @typing="getAsyncData"
                   @select="option => selected = option">

                   <template slot-scope="props">
                       <div class="media">
                           <div class="media-left">
                               <img width="32" :src="'./images/factory.jpg'"/>
                           </div>
                           <div class="media-content">
                               {{ props.option.description }}
                               <br>
                               <small>
                                   NAICS Code: {{ props.option.naics }},
                               </small>
                           </div>
                       </div>
                   </template>
               </b-autocomplete>
               <p class="control">
               <b-button type="is-primary"  @click="addToCart" expanded>Add to Cart</b-button>
      </p>
           </b-field>



          </article>

        </div>

      </div>
      <div class="tile is-parent">
        <article class="tile is-child notification has-background-white-ter">
          <p class="title">Shopping Cart</p>
          <p class="subtitle">Items In Cart: {{numberCartItems}} </p>

          <div ref="thecart" class="content">
          <section>
          <card-component title="" class="has-table">
            <cart-viewer data-url="/static/data-sources/clients.json" :checkable="false" v-bind:myCart="myProducts"    />

          </card-component>

          </section>
                    </div>
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child notification has-background-white-ter">

          <div class="content">
            <!-- Content -->
          </div>
        </article>
      </div>
    </div>

    <div class="tile" >
    <div class="tile is-parent">

      <article class="tile is-child notification has-background-grey ">
        <div class="content">
          <p class="title has-text-white">Trending Industries</p>
          <p class="subtitle has-text-white">Most downloaded reports</p>
          <div class="content">
          <div class="tile">
          <div class="tile is-parent is-vertical">
            <article class="tile is-child notification is-info has-background-grey-lighter">
              <p class="title has-text-grey-dark">Restaurants</p>
              <p class="subtitle has-text-grey-dark">NAICS Code 722511 – Full Service Restaurants</p>
              <figure class="image is-4by3">
                <img src="../assets/images/stock-photo-group-of-chef-preparing-food-in-the-kitchen-of-a-restaurant-564164815.jpg">
              </figure>
              <b-button type="is-success" @click="addToCartDirect('NAICS Code 722511 – Full-Service Restaurants','722511')" >Purchase</b-button>
          </article>
          <article class="tile is-child notification is-info has-background-grey-lighter">
              <p class="title has-text-grey-dark">Accounting</p>
              <p class="subtitle has-text-grey-dark">NAICS 541200 - Accounting, Tax Preparation, Bookkeeping, and Payroll Services</p>
              <figure class="image is-4by3">
                <img src="../assets/images/stock-photo-thoughtful-young-mixed-race-businessman-in-glasses-holding-paper-document-reading-banking-debt-1660489855.jpg">
              </figure>
              <b-button type="is-success" @click="addToCartDirect('NAICS 541200 - Accounting, Tax Preparation, Bookkeeping, and Payroll Services','541200')" >Purchase</b-button>
            </article>
            <article class="tile is-child notification is-info has-background-grey-lighter">
              <p class="title has-text-grey-dark">Home Remodeling and Renovation</p>
              <p class="subtitle has-text-grey-dark">NAICS 236118 - Residential Remodelers</p>
              <figure class="image is-4by3">
                <img src="../assets/images/stock-photo-carpenter-cutting-house-roof-supports-on-building-site-303640886.jpg">
              </figure>
              <b-button type="is-success" @click="addToCartDirect('NAICS 236118 - Residential Remodelers','236118')" >Purchase</b-button>
            </article>
          </div>
            <div class="tile is-parent is-vertical">
            <article class="tile is-child notification is-info has-background-grey-lighter">
                <p class="title has-text-grey-dark">Bakeries</p>
                <p class="subtitle has-text-grey-dark">NAICS Code 311811 – Retail Bakeries</p>
                <figure class="image is-4by3">
                  <img src="../assets/images/stock-photo-welcome-to-my-shop-shot-of-a-beautiful-female-baker-posing-in-the-bakery-store-369336572.jpg">
                </figure>
                <b-button type="is-success" @click="addToCartDirect('NAICS Code 311811 – Retail Bakeries','311811')" >Purchase</b-button>
              </article>
              <article class="tile is-child notification is-info has-background-grey-lighter">
                <p class="title has-text-grey-dark">Residential Construction</p>
                <p class="subtitle has-text-grey-dark">NAICS 236115 - New Single-Family Housing Construction (except For-Sale Builders)</p>
                <figure class="image is-4by3">
                  <img src="../assets/images/stock-photo-new-home-construction-build-with-wooden-truss-post-and-beam-framework-797485732.jpg">
                </figure>
                <b-button type="is-success" @click="addToCartDirect('NAICS 236115 - New Single-Family Housing Construction (except For-Sale Builders)','236115')" >Purchase</b-button>
              </article>
              <article class="tile is-child notification is-info has-background-grey-lighter">
                <p class="title has-text-grey-dark">Web Design, Software Development</p>
                <p class="subtitle has-text-grey-dark">NAICS 541511	Custom Computer Programming Services</p>
                <figure class="image is-4by3">
                  <img src="../assets/images/stock-photo-programmer-working-from-home-office-remote-1056727022.jpg">
                </figure>
                <b-button type="is-success" @click="addToCartDirect('NAICS 541511	Custom Computer Programming Services','541511')" >Purchase</b-button>
              </article>
                                        </div>
          </div>
                  </div>
        </div>
      </article>
    </div>
    </div>
  </div>

  </section>



  </div>
</template>

<script>
import CardComponent from './CardComponent'
import Navbar from "./features/Navbar"
import 'buefy/dist/buefy.css'
import debounce from 'lodash/debounce'
import CartViewer from './CartViewer'
import axios from 'axios'
 import { mapState } from "vuex";
 import { CART_ADD,CART_VALIDATE ,CART_MODE, CART_RESTAPI} from "../store/actions/cart";
  export default {
  components: {
    CardComponent,
      Navbar,
      CartViewer
},
      data() {
          return {
            isPayPalProblem: false,
            checkboxGroup: [],
            radioButton: [],
            checkRange: true,
            checkExact: false,
            showDetailIcon: false ,
            radio: [],
            dropdown_id: [],
            defaultOpenedDetails: [],
            orders: [],
              data: [],
              thetotal: "10",
              selected_id: [],
              input_id: [],
              input_id2: [],
              myItems: [],
              selected: null,
              isFetching: false,
              credentials: {
  sandbox: 'ARK1S926MJ-vd2UJD1gp3gLGrOAO6LRlxJ8Z8AKEOmD30hptzI1JETpBbm2j_oPrhMHRBl7IMdYUGM_9',
  production: ''
}
          }
      },
      watch: {
  isPayPalProblem: function() {
    console.log(this.isPayPalProblem)
  },
  status(thenew, theold) {
  console.log("status:",theold,thenew )

  if( thenew=="success") {
  this.loadAxiosData()
  }
  }
},
mounted () {
  console.log("hehe-buyReports.vue")
  this.$store.commit(CART_RESTAPI, this.$api.REST_API)

  // set the cart mode to interactive
  this.$store.commit(CART_MODE, "Interactive")


},

      computed: {

      ...mapState({
      mapaxiosData: state => state.cart.axiosData,
      status: state => state.cart.status,
      myProducts: state => state.cart.products,
      }),
      numberCartItems() {
        return this.myProducts.length
      },
                paypalTotal() {
          var total = 0.0
          this.myItems.forEach((element, index, array) => {
            total = total + parseFloat(element.price)
            });
            return total.toString()
          },
          isRange() {
          if( this.radio == "Range") {
            return true
          } else {
          return false
          }
          },
          computedgetIcon() {
            return "check"
          },
      },
      methods: {
      huh(index,naics) {
        console.log("index=",index,";naics=",naics)
        console.log("radio=",this.radio,";radiobutton=",this.radioButton)
      },

      getIcon(index,val) {
      console.log("getIcon(props.row.index,)",val,index,this.radioButton[index-1])
        return "check"
      },
      checkboxInput() {
      console.log("clickety-click",this.checkRange,this.checkExact)
      if( this.checkRange) {
        this.checkExact = false
      } else if (this.checkExact) {
      this.checkRange = false
      }
      },
      payment_completed_cb(res){
    console.log("Thank you! We'll send you a confirmation email soon with your invoice. ");
    console.log(res);
    this.isPayPalProblem = false

    var OrderBundle = { PayPal: res, Orders: this.orders, Items: this.myItems }
    this.$store.commit(ORDER_PARAMETERS, OrderBundle)

    this.$router.push({ name: "OrderConfirmation" });

},
payment_authorized_cb(res){
    this.isPayPalProblem = false
    console.log(res);
},
payment_cancelled_cb(res){
    console.log("The payment process has been canceled. No money was taken from your account.");
    console.log(res);
    this.isPayPalProblem = true
},
doCustomSalesInput(naics) {
        this.orders.forEach((element, index, array) => {
        if (element.naics == naics) {
        this.orders[index].salesrange = this.input_id[element.index]
        }
          });

console.log("doCustomSalesInput:"+naics)
console.log(this.orders)
},
doCustomSales(naics) {

this.orders.forEach((element, index, array) => {
if (element.naics == naics) {
      if( this.selected_id[element.index] == "Input" ) {
        this.orders[index].salesinput = true

      } else {
      this.orders[index].salesinput = false
      this.orders[index].salesrange = this.selected_id[element.index]
      }
}

      });

    console.log("doCustomSales:"+naics)
    console.log(this.orders)
},
          // You have to install and import debounce to use it,
          // it's not mandatory though.
          deleteItem(naics) {
          this.orders = this.orders .filter(function( obj ) {
                return obj.naics !== naics;
              });
          console.log("Deleting NAICS="+naics)
    },
    addToCartDirect: function(description,naics) {
      // console.log("click me")
      var element = this.$refs['thecart'];
    var top = element.offsetTop;
    window.scrollTo(0, top);

    // this.radio.push("Range")
    // this.radioButton.push(3)
    console.log("radio=",this.radio,";radiobutton=",this.radioButton)

    var order = {naics: naics, description: description, price: "$24.99", salesinput:false, salesrange: null, index:this.orders.length+1 }
      this.orders.push(order)

    var product = {report: "Standard-1",  naics: naics, description: description, salesType: "Range", salesrange: null, salesExact:0 }
    this.$store.commit(CART_ADD, product)

    var paypal_item =  {
        "name": "Norms and Ratios Report",
        "description": order.naics + "-" + order.description ,
        "quantity": "1",
        "price": "24.99",
        "currency": "USD"
        }
    this.myItems.push(paypal_item)

      this.defaultOpenedDetails.push(naics)

    },
          addToCart: function() {
            // console.log("click me")
            var order = {naics: this.selected.naics, description: this.selected.description, price: "$24.99" ,
              salesinput:false, salesrange: null ,index:this.orders.length+1}
            this.orders.push(order)

            var product = {report: "Standard-1",  naics: this.selected.naics, description: this.selected.description,
              salesType: "Range", salesrange: null, salesExact:0 }
            this.$store.commit(CART_ADD, product)

            var paypal_item =  {
                "name": "Norms and Ratios Report",
                "description": order.naics + "-" + order.description ,
                "quantity": "1",
                "price": "24.99",
                "currency": "USD"
                }
            this.myItems.push(paypal_item)

            this.defaultOpenedDetails.push(order.naics)
          //  this.radio.push("Range")
          //  this.radioButton.push(3)
        },


                    getAsyncData: debounce(function (name) {
          //  console.log(name)
              if (!name.length) {
                  this.data = []
                  return
              }
              this.isFetching = true
              var URI = this.$api.REST_API + '/api/NAICS/' + name
                              const options = {
   //   headers: {'X-API': authToken}
    };
              axios.get(URI,options)
              .then(({ data }) => {
            //          console.log(data)
                      this.data = []
                      // data.results.forEach((item) => this.data.push(item))
                      for (var i = 0, len = data.NAICS.length; i < len; i++) {
                          var element = data.NAICS[i]
              //            console.log(element)
                          var hit = {naics: element.naics, description: element.description }
                //          console.log(hit)
                        this.data.push(hit)
                        }
                      /*
                      data.results.forEach(function(element){
                          console.log(element)
                          var hit = {naics: element.release_date, description: element.title }
                          console.log(hit)
                        this.data.push(hit)
                        })
                        */
                  })
                  .catch((error) => {
                      this.data = []
                      throw error
                  })
                  .finally(() => {
                      this.isFetching = false
                  })
          }, 500)
      }
  }
</script>



<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/BuyReports.vue